module.exports = __webpack_public_path__ + "img/overview_build5.761e6639.png";